__turbopack_context__.v({
  "container": "Container-module__Xnw_lG__container",
});
